(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["biu-storefront"] && !Shopify.designMode) return;
  try {
    
function initBiu(scope){const root=scope.querySelector('[data-biu-site]');if(!root||root.dataset.ready)return;root.dataset.ready='true';const labels=JSON.parse(root.querySelector('[data-biu-labels]').textContent);const filters=Object.fromEntries(Array.from(root.querySelectorAll('[data-filter]')).map(x=>[x.dataset.filter,x]));const cards=Array.from(root.querySelectorAll('[data-stone]'));const sizes=Array.from(new Set(cards.flatMap(c=>Array.from(c.querySelector('[data-variant]').options).map(o=>o.textContent.trim()).filter(v=>v!=='Default Title'))));sizes.forEach(size=>{const option=document.createElement('option');option.value=size;option.textContent=size;filters.size.append(option)});function updateCard(card){const sel=card.querySelector('[data-variant]');const o=sel.selectedOptions[0];if(!o)return;card.querySelector('[data-current-price]').textContent=o.dataset.price;card.querySelector('[data-stock]').textContent=o.dataset.available==='true'?labels.available:labels.unavailable;const link=card.querySelector('[data-view]');link.href=link.dataset.productUrl+'?variant='+encodeURIComponent(o.value)}function apply(){Array.from(filters.type.options).forEach(o=>{o.hidden=!!(o.value&&filters.family.value&&o.dataset.family!==filters.family.value);o.disabled=o.hidden});let count=0;cards.forEach(card=>{let show=(!filters.family.value||card.dataset.family===filters.family.value)&&(!filters.type.value||card.dataset.type===filters.type.value)&&(!filters.shape.value||card.dataset.shape===filters.shape.value);if(filters.size.value){const select=card.querySelector('[data-variant]');const match=Array.from(select.options).find(o=>o.textContent.trim()===filters.size.value);show=show&&!!match;if(show){select.value=match.value;updateCard(card)}}card.hidden=!show;if(show)count++;else card.querySelectorAll('video').forEach(v=>v.pause())});root.querySelector('[data-empty]').hidden=count>0;root.querySelector('[data-results]').textContent=labels.results+': '+count}filters.family.addEventListener('change',()=>{filters.type.value='';filters.size.value='';apply()});filters.type.addEventListener('change',()=>{const option=filters.type.selectedOptions[0];if(option.dataset.family)filters.family.value=option.dataset.family;filters.size.value='';apply()});filters.shape.addEventListener('change',()=>{filters.size.value='';apply()});filters.size.addEventListener('change',apply);root.querySelector('[data-reset]').addEventListener('click',()=>{Object.values(filters).forEach(x=>x.value='');apply()});root.querySelectorAll('[data-select-family]').forEach(a=>a.addEventListener('click',()=>{filters.family.value=a.dataset.selectFamily;filters.type.value=a.dataset.selectType||'';filters.shape.value='';filters.size.value='';apply()}));cards.forEach(c=>{c.querySelector('[data-variant]').addEventListener('change',()=>updateCard(c));updateCard(c)});function prefill(text){const field=root.querySelector('#BiuMessage');field.value=text;field.focus({preventScroll:true})}root.querySelector('[data-enquire]').addEventListener('click',()=>prefill(Object.values(filters).filter(x=>x.value).map(x=>x.selectedOptions[0].textContent.trim()).join(' / ')));root.querySelectorAll('[data-design]').forEach(a=>a.addEventListener('click',()=>prefill(a.dataset.design)));root.querySelectorAll('video').forEach(v=>v.addEventListener('play',()=>root.querySelectorAll('video').forEach(other=>{if(other!==v)other.pause()})));const incoming=new URLSearchParams(location.search);if(incoming.has('sample'))prefill(incoming.get('sample'));if(incoming.has('colour'))filters.family.value=incoming.get('colour');if(incoming.has('gem'))filters.type.value=incoming.get('gem');apply();const customCategory=root.querySelector('[data-custom-filter="category"]'),customFamily=root.querySelector('[data-custom-filter="family"]');if(customCategory&&customFamily){const samples=Array.from(root.querySelectorAll('[data-custom-sample]'));function applyCustom(){let n=0;samples.forEach(card=>{card.hidden=!!((customCategory.value&&card.dataset.category!==customCategory.value)||(customFamily.value&&card.dataset.family!==customFamily.value));if(!card.hidden)n++;else card.querySelectorAll('video').forEach(v=>v.pause())});root.querySelector('[data-custom-results]').textContent=labels.results+': '+n;root.querySelector('[data-custom-empty]').hidden=n>0}customCategory.addEventListener('change',applyCustom);customFamily.addEventListener('change',applyCustom);root.querySelector('[data-custom-reset]').addEventListener('click',()=>{customCategory.value='';customFamily.value='';applyCustom()});root.querySelectorAll('[data-custom-category]').forEach(a=>a.addEventListener('click',()=>{customCategory.value=a.dataset.customCategory;customFamily.value=a.dataset.customFamily;applyCustom()}));root.querySelector('[data-custom-enquire]').addEventListener('click',()=>prefill([customCategory,customFamily].filter(x=>x.value).map(x=>x.selectedOptions[0].textContent.trim()).join(' / ')));if(incoming.has('jewelry'))customCategory.value=incoming.get('jewelry');if(incoming.has('jewelry_colour'))customFamily.value=incoming.get('jewelry_colour');applyCustom()}}initBiu(document);document.addEventListener('shopify:section:load',e=>initBiu(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
